import * as React from 'react';
import { Helmet } from 'react-helmet';

interface PageDescriptionProps {
  favicon: string;
  description: string;
  title: string;
  pageUrl: string;
  ampURL: string | null;
}

export const PageDescription: React.FunctionComponent<PageDescriptionProps> = ({ description, favicon, pageUrl, title, ampURL }) => (
  <Helmet>
    <title>{title}</title>
    <meta charSet="utf-8" />
    <meta name="description" content={description} />
    <link rel="icon" href={favicon} type="image/png" />
    <link rel="canonical" href={pageUrl} />
    {ampURL ? <link rel="amphtml" href={ampURL} /> : null}
  </Helmet>
);
